import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MoviesService } from '../services/movies.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomDataService } from '../services/custom-data.service';
import { ThrowStmt } from '@angular/compiler';
import * as $ from 'jquery'
import { UsersService } from '../services/users.service';
import { ShowTailerComponent } from '../show-tailer/show-tailer.component';

@Component({
  selector: 'app-movie-details',
  templateUrl: './movie-details.component.html',
  styleUrls: ['./movie-details.component.css']
})
export class MovieDetailsComponent implements OnInit {

  myId ; allMovies ; movie
 url ; show   ; schdule ; showSchedule:boolean ; user :boolean = true  
 commentError:boolean = false  ;rateError:boolean= false  ; 
  myDate: Date;
  day: number;
  month: number;
  convertD: any;
  convertM: any;
  year: number;
  Day1: string;
  hour: any;
  min: any;
  ampm: any;
  hours: any;
  showReviewPost: boolean = true;
  constructor(private current:UsersService,private _router:Router , private _activatedroute:ActivatedRoute , private movies:MoviesService , private custom:CustomDataService) 
  {
    this._activatedroute.params.subscribe(params => {
      this.myId = params['movieId'];
    });
    this.allMovies = this.movies.movies ; 
    for(let item of this.allMovies)
    {
      if(item.id == this.myId)
      {
        this.movie = item ;
        break
      }
    }
    for(let schedule of this.custom.Day1)
    {
      if(schedule.movieId == this.myId)
      {
        this.schdule = schedule ; 
        this.showSchedule = true 
        break
      }
    }
    if(this.current.currentUser != 0)
    {
      this.user = false
      this.user = false
      for(let user of this.current.users)
      {
      for(let review of this.movie.reviews)
      {
        if(review.email === user.email )
        {
          this.showReviewPost = false ;
          break
        }
      }
      }
    }
  }

  ngOnInit() 
  {
    this._activatedroute.params.subscribe(params => {
      this.myId = params['movieId'];
      this.allMovies = this.movies.movies ; 
      this.showSchedule = false 
    for(let item of this.allMovies)
    {
      if(item.id == this.myId)
      {
        this.movie = item ;
        break 
      }
    }
    for(let schedule of this.custom.Day1)
    {
      if(schedule.movieId == this.myId)
      {
        this.schdule = schedule ; 
        this.showSchedule =true 
        break
      }
    }
    if(this.current.currentUser != 0)
    {

      this.user = false
      for(let user of this.current.users)
      {
      for(let review of this.movie.reviews)
      {
        if(review.email === user.email )
        {
          this.showReviewPost = false ;
          break
        }
      }
      }
      
    }
   

    });
    /**********************************jquery****** */
    $(document).ready(function(){

      $("body").on("click",".con-sub img",function(){
        $(".mean").attr("src",$(this).attr("src"));
        $(this).parent().siblings().children("img").removeClass("act")
        $(this).addClass("act")
      });

      $("body").on("click",".con-stars li i",function(){

        $(this).parent().siblings().children("i").removeClass("fa-star").addClass("fa-star-o");
        $(this).parent().siblings().attr("id","")
        $(this).removeClass("fa-star-o").addClass("fa-star");
        $(this).parent().attr("id","rate")
        $(this).parent().prevAll().children("i").removeClass("fa-star-o").addClass("fa-star");
     
      });

    });
  }
  goToType(type)
  {
    this._router.navigate(["/Movie/Type",type.toUpperCase()]);
  }
  displayTrailler(id)
  {
    this._router.navigate(["/Movie/Details",id ,"true"]);

  }
  Review()
  {
    var comment = (<HTMLInputElement>document.getElementById("comment")).value ; 
    var star = (<HTMLElement>document.getElementById("rate")) 
    var y = 0 
    if(comment === "")
    {
      this.commentError = true 
      y += 1 
    }
    else
    {
      this.commentError = false 
    }
    if(star === null)
    {
      this.rateError = true 
      y += 1 
    }
    else
    {
      this.rateError = false
    }
    if(y ===0)
    {
      var userId = this.current.currentUser ;
      var userData  
      var Username , Useremail , Userrate  , myDate
     
      for(let user of this.current.users )
      {
        if(user.id === userId)
        {
          userData = user 
          break 
        }
      }
      Username = userData.firstName
      Useremail = userData.email 
      Userrate = star.getAttribute("data-toggle")
      myDate=this.getDate()
      var review = {
        name:Username , 
        email : Useremail ,
        stars:Userrate , 
        date : myDate , 
        comment:comment
      }
      this.showReviewPost = false 
      this.movie.reviews.push(review)
      console.log(this.movie.reviews)

    }
  }
  getDate()
  {
    this.myDate  = new Date(); 
    this.day = Number(this.myDate.getDate()) ;
    this.month = Number(this.myDate.getMonth() + 1)
    this.convertD = this.convert(this.day , this.month)[0]
    this.convertM = this.convert(this.day , this.month)[1]
    this.year = this.myDate.getFullYear();
    this.Day1 = this.convertM +" "+ this.convertD + " , " + this.year ;
    this.hour = this.myDate.getHours()
    this.min = this.myDate.getMinutes()
    this.ampm = this.hour >= 12 ? 'pm':'am' 
    this.hour = this.hour % 12 
    this.min = this.min >10 ?  "0"+this.min.toString() : this.min
    this.hour = this.hour? this.hour : 12 
    var time = this.hour + ":" + this.min + " " + this.ampm
    return this.Day1 + " at "+ time 
  }
  convert(day,month)
  {
    var convertDay , convertMonth 
    if(day < 10)
    {
      convertDay = "0"+day 
    }
    else 
    {
      convertDay = day 
    }

    if(month == 1 )
    {
      convertMonth = "January"
    }
    else if(month == 2 )
    {
      convertMonth = "February"
    }
    else if(month == 3 )
    {
      convertMonth = "March"
    }
    else if(month == 4 )
    {
      convertMonth = "April"
    }
    else if(month == 5 )
    {
      convertMonth = "May"
    }
    else if(month == 6 )
    {
      convertMonth = "June"
    }
    else if(month == 7 )
    {
      convertMonth = "July"
    }
    else if(month == 8 )
    {
      convertMonth = "August"
    }
    else if(month == 9 )
    {
      convertMonth = "September"
    }
    else if(month == 10 )
    {
      convertMonth = "October"
    }
    else if(month == 11 )
    {
      convertMonth = "November"
    }
    else
    {
      convertMonth = "December"
    }
    return [convertDay,convertMonth]
  }
}
